import React from 'react';
import {
  SectionSummary, SectionSummaryDescription, SectionSummaryTitle,
} from '../styles';

export default function Summary() {
  const desc = 'Pin your most important Livewire wires to the top of your profile.';
  // Add the following part when `mentioned` is implemented.
  //   "This might be those you have published or been mentioned."
  return (
    <SectionSummary>
      <SectionSummaryTitle>your featured content</SectionSummaryTitle>
      <SectionSummaryDescription>{desc}</SectionSummaryDescription>
    </SectionSummary>
  );
}
